export const GET_COMPANY_INSIGHTS_START =
  'INSIGHTS::GET_COMPANY_INSIGHTS_START';
export const GET_COMPANY_INSIGHTS_SUCCESS =
  'INSIGHTS::GET_COMPANY_INSIGHTS_SUCCESS';
export const GET_COMPANY_INSIGHTS_FAILS =
  'INSIGHTS::GET_COMPANY_INSIGHTS_FAILS';
